<script>
import Vue from 'vue'

function getIndicesOf (searchStr, str, caseSensitive) {
  if (!searchStr || searchStr.length === 0) {
    return []
  }

  let searchStrLen = searchStr.length
  let startIndex = 0
  let index
  let indices = []

  if (!caseSensitive) {
    str = str.toLowerCase()
    searchStr = searchStr.toLowerCase()
  }

  while ((index = str.indexOf(searchStr, startIndex)) > -1) {
    indices.push(index)
    startIndex = index + searchStrLen
  }
  return indices
}

export default Vue.component('lxTextHighlight', {
  props: {
    text: {
      type: String,
      default: null
    },
    searchString: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'blue-grey'
    }
  },
  render (h) {
    let indices = getIndicesOf(this.searchString, this.text)
    let parts = []

    if (indices?.length > 0) {
      let oldStart = 0

      for (let items in indices) {
        let res = this.text.substring(oldStart, indices[items])
        oldStart = indices[items] + this.searchString.length

        if (res.length > 0) {
          let noHighlightPart = h('span', {}, res)
          parts.push(noHighlightPart)
        }

        let highlightText = this.text.substring(indices[items], oldStart)
        let highlightPart = h('span', { staticClass: this.color + '--text font-weight-bold' }, highlightText)
        parts.push(highlightPart)
      }

      let textnode = this.text.substring(oldStart)
      let noHighlightPart2 = h('span', {}, textnode)
      parts.push(noHighlightPart2)
    } else {
      let nothingToHighlight = h('span', {}, this.text)
      parts.push(nothingToHighlight)
    }

    return h(
      'div', {}, parts
    )
  }
})
</script>
